export enum SourceDocumentType {
  Document = 1,
  Chase = 2,
  Pend = 3,
  WorkingDocument = 4,
  Archive = 5,
  DocumentThumbnail = 6,
}
